import React from 'react';

const TagRef = () => {
    return (

        <div>
            <p className="black"><strong>Additional tags can be applied to Auto Scaling Groups to
                control
                various
                settings for Instance Orchestrator:</strong></p>
            <p><span className="text-primary">xosphere.io/instance-orchestrator/<span
                className="text-warning">allowed-instance-types</span></span><br/>
                Explicit list of allowed instances types for this Auto Scaling Group. Accepts a
                comma-delimited list
                of instance types
                (e.g. m4.large,m5.large,c5.large,r4large). By default, this value is not set,
                meaning
                Instance
                Orchestrator will
                automatically determine eligible instance types based on the specs of the On-Demand
                instance
                being
                replaced.</p>
            <p><span className="text-primary">xosphere.io/instance-orchestrator/<span
                className="text-warning">bid-multiplier</span></span><br/>
                The bid multiplier when bidding on Spot instances. Accepts floating point values
                greater than
                0.0. By
                default, this
                value is 0.9, meaning Instance Orchestrator will place Spot bids for 90% of the
                On-Demand
                instance
                price.</p>
            <p><span className="text-primary">xosphere.io/instance-orchestrator/<span
                className="text-warning">enable-burstable</span></span><br/>
                Allow On-Demand instances to be replaced by equivalent burstable Spot instances
                (e.g. the t2
                family). Accepts true
                or false. By default, this value is false, meaning Instance Orchestrator will not
                replace
                any
                non-burstable On-
                Demand instance with a burstable Spot instance.</p>
            <p><span className="text-primary">xosphere.io/instance-orchestrator/<span
                className="text-warning">enable-cloudwatch</span></span><br/>
                Flag indicating whether or not CloudWatch metrics should be published. Accepts
                Boolean
                values true
                or false. By
                default, this value is set to false, meaning no CloudWatch metrics will be
                published. Note,
                setting
                this value to true
                will incur additional AWS expense for custom CloudWatch metrics.</p>
            <p><span className="text-primary">xosphere.io/instance-orchestrator/<span
                className="text-warning">min-on-demand</span></span><br/>
                Minimum number of On-Demand instances to be running in this Auto Scaling Group.
                Accepts
                integer
                values from 0
                to the total number of instances in this Auto Scaling Group. By default, this value
                is set
                to 0,
                meaning all On-
                Demand instances in the Auto Scaling Group can be replaced with Spot instances.</p>
            <p><span className="text-primary">xosphere.io/instance-orchestrator/<span
                className="text-warning">notify-on-spot-launch</span></span><br/>
                Flag indicating whether SNS notifications should be sent when Spot instances are
                launched in
                this
                Auto Scaling
                Group. Accepts Boolean values true or false. By default, this value is set to false,
                meaning
                no
                messages are sent
                when Instance Orchestrator launches a replacement Spot instance.</p>
            <p><span className="text-primary">xosphere.io/instance-orchestrator/<span
                className="text-warning">percent-on-demand</span></span><br/>
                Percentage of On-Demand instances to be running in this Auto Scaling Group. Accepts
                floating
                point
                values from
                0.0 to 100.0. By default, this value is set to 0.0, meaning all On-Demand instances
                in the
                Auto
                Scaling Group can be
                replaced with Spot instances.</p>
            <p><span className="text-primary">xosphere.io/instance-orchestrator/<span
                className="text-warning">prefer-reserved-instances</span></span><br/>
                Flag indicating whether or not unused Reserved instances should be taken into
                account when
                deciding
                whether or
                not to replace an instance with a Spot instance. Accepts Boolean values true or
                false. By
                default,
                this value is set to
                true, meaning an On-Demand instance that is currently using a Reserved reservation
                will not
                be
                replaced by a Spot
                instance. This setting can be useful in scenarios where Reserved instances have been
                purchased or
                can be used in
                another account that is linked to the current account for billing purposes.</p>
        </div>
    )

};

export default TagRef;